//获取cookie、
export function getCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	if (arr = document.cookie.match(reg))
	return (unescape(arr[2]));
	else
	return null;
}
	
//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate() + expiredays);
	document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};


//设置cookie,增加到vue实例方便全局调用
export function setCookieEXP (c_name, value, sec) {
	if(!sec){
		sec = 3600;//默认一小时
	}
	var exdate = new Date();
	exdate = new Date(exdate.getTime() + sec * 1000);
	document.cookie = c_name + "=" + escape(value) + ((sec == null) ? "" : ";expires=" + exdate.toGMTString());
};
	
//删除cookie
export function delCookie (name) {
	var exp = new Date();
	exp.setTime(exp.getTime() - 1);
	var cval = getCookie(name);
	if (cval != null)
	document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};


export function fixedFn ($box, $content, $header, $footer) {
	var startPos = {x:0,y:0};
	var endPos = {x:0,y:0};
	var isScrolling = 0;
	$box.off('touchstart');
	$box.off('touchend');
	
	$box.on('touchstart', function(event){
		var touch = event.targetTouches[0];	 //touches数组对象获得屏幕上所有的touch，取第一个touch
		startPos = {x:touch.pageX,y:touch.pageY,time:+new Date};	//取第一个touch的坐标值
		isScrolling = 0;	 //这个参数判断是垂直滚动还是水平滚动

		$box.on('touchmove', function(event){
			if($content.height() <= $box.height()){
				return event.preventDefault();
			}
			var touch = event.targetTouches[0];
			endPos = {x:touch.pageX - startPos.x,y:touch.pageY - startPos.y};
			isScrolling = Math.abs(endPos.x) < Math.abs(endPos.y) ? 1:0;	//isScrolling为1时，表示纵向滑动，0为横向滑动
			if(isScrolling == 1 && (touch.pageY - startPos.y) > 0 &&	$box[0].scrollTop == 0){
				event.preventDefault();
			}
			if(isScrolling == 1 && (touch.pageY - startPos.y) < 0 &&	$box[0].scrollTop >= $content.height() - $box.height() &&	$box[0].scrollTop > 0){
				event.preventDefault();
			}
		});
	});
	$box.on('touchend', function(event){
		$box.off('touchmove');
	});

	$header.on('touchmove', function(event){
		event.preventDefault();
	});
	$footer.on('touchmove', function(event){
		event.preventDefault();
	});


	$('.load-cover').on('touchstart', function(event){
		event.preventDefault();
	});
	
};




//////////////////
// WEBPACK FOOTER
// ./static/js/cookieUtil.js
// module id = Iztm
// module chunks = 82